import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';

import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  startAfter,
  getCountFromServer
} from 'firebase/firestore';

import './journal.css';

function GeneralOphthalmology() {

  const [ophthalmologyBooks, setOphthalmologyBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch General Ophthalmology Resources
  const fetchOphthalmologyBooks = async (page) => {

    try {

      const pageSize = 6;

      const resourcesRef = collection(db, 'mainresources');

      let q = query(
        resourcesRef,
        where(
          'resourceType',
          '==',
          'General Ophthalmology'
        ),
        orderBy('created_at', 'desc'),
        limit(pageSize)
      );

      // Pagination
      if (page > 1 && lastVisible) {

        q = query(
          resourcesRef,
          where(
            'resourceType',
            '==',
            'General Ophthalmology'
          ),
          orderBy('created_at', 'desc'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);

      const books = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setOphthalmologyBooks(books);

      setLastVisible(
        querySnapshot.docs[querySnapshot.docs.length - 1]
      );

      // Count Total Documents
      const countSnapshot = await getCountFromServer(
        query(
          resourcesRef,
          where(
            'resourceType',
            '==',
            'General Ophthalmology'
          )
        )
      );

      const pages = Math.ceil(
        countSnapshot.data().count / pageSize
      );

      setTotalPages(pages);

    } catch (error) {

      console.error(
        'Error fetching General Ophthalmology resources:',
        error
      );
    }
  };

  // Pagination Handler
  const paginate = (page) => {
    setCurrentPage(page);
    fetchOphthalmologyBooks(page);
  };

  useEffect(() => {
    fetchOphthalmologyBooks(currentPage);
  }, [currentPage]);

  return (

    <div className="journal-page-container">

      {/* HERO SECTION */}
      <section className="hero">

        <div className="hero-image">
          <img
            src="/imgbook.png"
            alt="General Ophthalmology Resources"
          />
        </div>

        <div className="hero-content">

          <h1>Eye Care Digital Library</h1>

          <p>
            Explore professional educational books,
            academic references, and clinical resources
            covering the fundamentals and advanced
            concepts of ophthalmology and eye care.
          </p>

        </div>

      </section>

      {/* PAGE HEADER */}
      <div className="journal-heading-section">

        <h2>General Ophthalmology</h2>

        <p>
          Access comprehensive learning materials related
          to ocular anatomy, eye diseases, diagnostic
          techniques, treatment procedures, patient care,
          and modern ophthalmic clinical practices.
        </p>

      </div>

      {/* BOOKS GRID */}
      <div className="articles-container">

        {ophthalmologyBooks.length > 0 ? (

          ophthalmologyBooks.map((book) => (

     

            <div key={book.id} className="article-item">

  {book.coverImageURL && (
    <img
      src={book.coverImageURL}
      alt={book.title}
      className="book-cover-image"
    />
  )}

  <div className="article-content">

    <h4>{book.title}</h4>

    <div className="book-meta-data">

      {book.author && (
        <p>
          <strong>Author:</strong> {book.author}
        </p>
      )}

      {book.publication_year && (
        <p>
          <strong>Year:</strong> {book.publication_year}
        </p>
      )}

      {book.isbn && (
        <p>
          <strong>ISBN:</strong> {book.isbn}
        </p>
      )}

    </div>

    {book.description && (
      <p className="book-description">
        {book.description}
      </p>
    )}

    {book.pdfFileURL && (
      <a
        href={book.pdfFileURL}
        target="_blank"
        rel="noopener noreferrer"
        className="read-article-btn"
      >
        Read Resource
      </a>
    )}

  </div>

</div>

          ))

        ) : (

          <div className="no-books-found">

            <h3>No Resources Available</h3>

            <p>
              No General Ophthalmology resources
              have been uploaded yet.
            </p>

          </div>

        )}

      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (

        <div className="pagination-container">

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from(
            { length: totalPages },
            (_, index) => (
              <button
                key={index + 1}
                className={`pagination-button ${
                  currentPage === index + 1
                    ? 'active'
                    : ''
                }`}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            )
          )}

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>

        </div>

      )}

    </div>
  );
}

export default GeneralOphthalmology;